import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { DomainView, CaseView } from '../layouts';
import { CreditorGroup, CreditorView } from 'us.collection.creditor/layouts';
import {
	TransactionLayout,
	ArLayout,
} from 'us.collection.transactions/layouts';
import Case from 'us.collection.case';
import Creditor from 'us.collection.creditor';
import Debtor from 'us.collection.debtor';
import Partpayments from 'us.collection.partpayments';
import Transactions from 'us.collection.transactions';
import RoutinesAndActivities from 'us.collection.routines-and-activities';
import Documents from 'us.collection.documents';
import Admin from 'us.collection.admin';
import { CaseType } from 'us.helper/types/enums';
import { asyncRoutes } from 'us.collection/functions';

import {
	MainSearch,
	UserRoleSettings,
	UserSettings,
	Home,
	FollowUps,
} from './asyncRoutes';
import { BureauView } from 'us.collection.admin/layouts';

export default (caseNo: number) => {
  const MainViewModules = [Admin];
  const CaseViewModules = [
    Case,
    Partpayments,
    RoutinesAndActivities,
    Transactions,
    Documents,
    Debtor,
  ];
  const TransactionViewModels = [Transactions];
  const CreditorModules = [Creditor];
  
  return [
    <Route key='search' path={'/search'} element={<MainSearch />} />,
    <Route key='/user-role-settings' path={'/user-role-settings'} element={<UserRoleSettings />} />,
    <Route key='/user-settings' path={'/user-settings'} element={<UserSettings />} />,
    <Route key='/follow-up' path={'/follow-up/:followUpId?/:filterId?'} element={<FollowUps />} />,
    <Route key='/' path={'/'} element={<Home />} />,
    
    // Creditor routes - FIXED VERSION
    <Route
      key='creditor-routes'
      path='/creditor/:creditorId/*'
      element={
        <DomainView isFollowup='false'>
          <CreditorView.Layout>
            <Routes>
              {CreditorModules.map(({ Routes: ModuleRoutes }, index) => {
                const routes = asyncRoutes(
                  '', // Remove the parent path - child routes should be relative
                  caseNo,
                  CaseType.C,
                  ModuleRoutes.Containers.creditorContainers
                );
                                
                return (
                  <React.Fragment key={'creditor-' + index}>
                    {routes}
                  </React.Fragment>
                );
              })}
              {/* Add a catch-all route for debugging */}
              <Route path="*" element={<div>Creditor Route Matched - No Container Found</div>} />
            </Routes>
          </CreditorView.Layout>
        </DomainView>
      }
    />,
    
    // Creditor group routes - FIXED VERSION
    <Route
      key='creditor-group-routes'
      path='/creditor-group/:creditorGroupId/*'
      element={
        <DomainView isFollowup='false'>
          <CreditorGroup.Layout>
            <Routes>
              {CreditorModules.map(({ Routes: ModuleRoutes }, index) => {
                const routes = asyncRoutes(
                  '', // Remove the parent path - child routes should be relative
                  caseNo,
                  CaseType.C,
                  ModuleRoutes.Containers.creditorGroupContainers
                );
                
                return (
                  <React.Fragment key={'creditor-group-' + index}>
                    {routes}
                  </React.Fragment>
                );
              })}
              <Route path="*" element={<div>Creditor Group Route Matched - No Container Found</div>} />
            </Routes>
          </CreditorGroup.Layout>
        </DomainView>
      }
    />,
    
    // Payment routes - FIXED VERSION
    <Route
      key='payment-routes'
      path='/payment/:payment/*'
      element={
        <DomainView isFollowup='false'>
          <TransactionLayout>
            <Routes>
              {TransactionViewModels.map(({ Routes: ModuleRoutes }, index) => {
                const routes = asyncRoutes(
                  '', // Remove the parent path - child routes should be relative
                  caseNo,
                  CaseType.C,
                  ModuleRoutes.TransactionContainers
                );
                
                return (
                  <React.Fragment key={'payment-' + index}>
                    {routes}
                  </React.Fragment>
                );
              })}
              <Route path="*" element={<div>Payment Route Matched - No Container Found</div>} />
            </Routes>
          </TransactionLayout>
        </DomainView>
      }
    />,
    
    // AR routes - FIXED VERSION
    <Route
      key='ar-routes'
      path='/ar/:arNumber/*'
      element={
        <DomainView isFollowup='false'>
          <ArLayout>
            <Routes>
              {TransactionViewModels.map(({ Routes: ModuleRoutes }, index) => {
                const routes = asyncRoutes(
                  '', // Remove the parent path - child routes should be relative
                  caseNo,
                  CaseType.C,
                  ModuleRoutes.ArContainers
                );
                
                return (
                  <React.Fragment key={'ar-' + index}>
                    {routes}
                  </React.Fragment>
                );
              })}
              <Route path="*" element={<div>AR Route Matched - No Container Found</div>} />
            </Routes>
          </ArLayout>
        </DomainView>
      }
    />,
    
    // Case routes - FIXED VERSION
    <Route
      key='case-routes'
      path='/case/:exCaseNo/*'
      element={
        <DomainView isFollowup='false'>
          <CaseView.Layout>
            <Routes>
              {CaseViewModules.map(({ Routes: ModuleRoutes }, index) => {
                const routes = asyncRoutes(
                  '', // Remove the parent path - child routes should be relative
                  caseNo,
                  CaseType.C,
                  ModuleRoutes.Containers
                );
                
                return (
                  <React.Fragment key={'case-' + index}>
                    {routes}
                  </React.Fragment>
                );
              })}
              <Route path="*" element={<div>Case Route Matched - No Container Found</div>} />
            </Routes>
          </CaseView.Layout>
        </DomainView>
      }
    />,
    
    // Bureau routes - FIXED VERSION
    <Route
      key='bureau-routes'
      path='/bureau/*'
      element={
        <DomainView isFollowup='false'>
          <BureauView.Layout>
            <Routes>
              {MainViewModules.map(({ Routes: ModuleRoutes }, index) => {
                const routes = asyncRoutes(
                  '', // Remove the parent path - child routes should be relative
                  caseNo,
                  CaseType.C,
                  ModuleRoutes.BureauContainers
                );
                
                return (
                  <React.Fragment key={'bureau-' + index}>
                    {routes}
                  </React.Fragment>
                );
              })}
              <Route path="*" element={<div>Bureau Route Matched - No Container Found</div>} />
            </Routes>
          </BureauView.Layout>
        </DomainView>
      }
    />,
  ];
};